import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { InfoboxComponent } from '@recruitee/components/infobox';
import { TranslatePipe } from '@recruitee/i18n';

@Component({
  selector: 'rt-assigned-product-message',
  templateUrl: './assigned-product-message.component.html',
  styleUrls: ['./assigned-product-message.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': 'disabled',
  },
  standalone: true,
  imports: [InfoboxComponent, TranslatePipe],
})
export class AssignedProductMessageComponent {
  @Input() public disabled: boolean = false;
  @Output() public finishOrder = new EventEmitter<void>();
}
